import Keycloak from "keycloak-js";

const KeycloakConfig = {
  url: Config.keycloakUrl,
  realm: Config.keycloakRealm,
  clientId: Config.keycloakClientId,
};

export const keycloakInstance = new Keycloak(KeycloakConfig);
